export default __webpack_public_path__ + "../staticImages/sprite-dhl_mini.png";